export enum UserAvatarPresetType {
  userAvatarBig = 'userAvatarBig',
  userAvatarXBig = 'userAvatarXBig',
  userAvatarLarge = 'userAvatarLarge',
  userAvatarMedium = 'userAvatarMedium',
  userAvatarXSmall = 'userAvatarXSmall',
  userAvatarSmall = 'userAvatarSmall',
}
